import React from 'react';
import './../../css/CardRedirection.css';
import {connect} from 'react-redux';
import {getMerchantData,unProcessableEntity} from './../../constants/merchantData';
import {OnRADenyPageLoad, OnRADenyPageCancel} from './../../components/SiteCat/SiteCat'

class RaDeny extends React.Component{

  constructor() {
    super();

    this.state = {
      merchantName:"",
      authCode:""
    };
  }

  componentWillMount = () => {
    this.setState({
      merchantName : this.props.lockedposts.merchant
    });
  }

  componentDidMount() {
    OnRADenyPageLoad(this.state.merchantName);
    const cancelUrlData = this.props.lockedposts.cancelUrl;
    this.setState({
      merchantName : this.props.lockedposts.merchant,
      authCode : this.props.lockedposts.authcode,
      cancelUrlData
    });
  }

  handleCancel = event => {
    OnRADenyPageCancel(this.state.merchantName)
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    unProcessableEntity(data);
  }

  render() {
    const merchantData = getMerchantData(this.state.merchantName)
    return(
      <React.Fragment>
      <div className="row">
        <div className="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
          <div className="ra-deny-header">Your account cannot currently be accessed</div>
          <div className="ra-deny-section" x-ms-format-detection="none">Your request cannot be completed at this time. Please contact us immediately at <b>1-866-868-3119</b>.</div>
          <div className="ra-deny-cancel">
              <button class="changebtnproperty" onClick={this.handleCancel}>Cancel</button>
          </div>
        </div>
      </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lockedposts: state
  }
}

export default connect(mapStateToProps)(RaDeny);
